import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useAuth } from '../../../context/AuthContext';
import axios from "axios";
const MobileNavbarAdmin = (props) => {
    const { t, i18n } = useTranslation()
    const { user } = useAuth();
    const [logo, setLogo] = useState('');
    const getlogo = async () => {
        try {
            const headerss = {
                "accept": "*/*",
                'Access-Control-Allow-Credentials': 'false',
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json'
            }
            await axios({
                method: 'get',
                url: "https://express.heryerdeingilizce.com/getlogo",
                headers: headerss
            }).then(res => {
                setLogo(res.data[0])
            }
            );
        }
        catch (err) {
        }
    }
    useEffect(() => {
        getlogo();
    }, [])

    return (
        <nav class="navbar navbar-expand-lg bg-body-tertiary">
            <div class="container-fluid" style={{ backgroundColor: "white" }}>
                <a className="navbar-brand" href="/">
                    <img src={logo['photo']} alt="logo" />
                </a>
                <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                    <span class="navbar-toggler-icon"></span>
                </button>

                <div class="collapse navbar-collapse" id="navbarSupportedContent">
                    <ul class="navbar-nav me-auto mb-2 mb-lg-0">

                        <li class="nav-item dropdown">
                            <a class="nav-link dropdown-toggle" role="button" data-bs-toggle="dropdown" >
                                {t("individualUserSettings")}
                            </a>
                            <ul class="dropdown-menu">
                                <li><a class="dropdown-item" href="/admin/createusertype">Create User Type</a></li>
                                {/* <li><a class="dropdown-item" href="/admin/usertypelist">User Types List</a></li> */}
                                <li><a class="dropdown-item" href="/admin/userlist">{t('userList')}</a></li>
                                <li><a class="dropdown-item" href="/admin/schoollist">  {t('schoolList')}</a></li>
                                <li><a class="dropdown-item" href="/admin/createschool"> {t('createSchool')}</a></li>
                                <li><a class="dropdown-item" href="/admin/corporateuserlist">  {t('corporateuserList')}</a></li>
                            </ul>
                        </li>
                        <hr />

                        <li class="nav-item dropdown">
                            <a class="nav-link dropdown-toggle" role="button" data-bs-toggle="dropdown" >
                                {t("tickets")}
                            </a>
                            <ul class="dropdown-menu">
                                {/* <li><a class="dropdown-item" href="/admin/ticketlist">  {t('ticketlist')}</a></li> */}
                                <li><a class="dropdown-item" href="/admin/searchticket"> {t('searchticket')}</a></li>
                                {/* <li><a class="dropdown-item" href="/admin/ticketdetail"> {t('ticketdetail')}</a></li> */}
                            </ul>
                        </li>
                        <hr />

                        <li class="nav-item dropdown">
                            <a class="nav-link dropdown-toggle" role="button" data-bs-toggle="dropdown" >
                                {t("corporateUserSettings")}
                            </a>
                            <ul class="dropdown-menu">
                                <li><a class="dropdown-item" href="/admin/schoollist">  {t('schoolList')}</a></li>
                                <li><a class="dropdown-item" href="/admin/createschool"> {t('createSchool')}</a></li>
                            </ul>
                        </li>

                        <hr />
                        <li class="nav-item dropdown">
                            <a class="nav-link dropdown-toggle" role="button" data-bs-toggle="dropdown" >
                                {t("websiteuser")}
                            </a>
                            <ul class="dropdown-menu">
                                <li><a class="dropdown-item" href="/admin/createmoderator">{t('createmoderator')}</a></li>
                                <li><a class="dropdown-item" href="/admin/moderatorlist">{t('moderatorlist')}</a></li>

                            </ul>
                        </li>
                        <hr />
                        <li class="nav-item dropdown">
                            <a class="nav-link dropdown-toggle" role="button" data-bs-toggle="dropdown" >
                                {t('financialSettings')}
                            </a>
                            <ul class="dropdown-menu">
                                <li><a class="dropdown-item" href="/admin/bankaccount">{t('bankAccounts')}</a></li>
                                <li><a class="dropdown-item" href="/admin/packageprice">{t('packagesAndPrices')}</a></li>
                                <li><a class="dropdown-item" href="/admin/packagelist">{t('packagesList')}</a></li>
                                <li><a class="dropdown-item" href="/admin/payment">  {t("paymentRequests&newRegister")}</a></li>
                            </ul>
                        </li>
                        <hr />
                        <li class="nav-item dropdown">
                            <a class="nav-link dropdown-toggle" role="button" data-bs-toggle="dropdown" >
                                {t('coupensettings')}
                            </a>
                            <ul class="dropdown-menu">
                                <li><a class="dropdown-item" href="/admin/packagelist">{t('coupenList')}</a></li>
                            </ul>
                        </li>
                        <hr />

                        <li class="nav-item dropdown">
                            <a class="nav-link dropdown-toggle" role="button" data-bs-toggle="dropdown" >
                                {t('courseSettings')}
                            </a>
                            <ul class="dropdown-menu">
                                <li><a class="dropdown-item" href="/admin/createcourse">{t('createCourse')} </a></li>
                                <li><a class="dropdown-item" href="/admin/courselist"> {t('courseList')}</a></li>
                            </ul>
                        </li>

                        <hr />
                        <li class="nav-item dropdown">
                            <a class="nav-link dropdown-toggle" role="button" data-bs-toggle="dropdown" >
                                Subject Settings
                            </a>
                            <ul class="dropdown-menu">
                                <li><a class="dropdown-item" href="/admin/createsubject">Create Subject</a></li>
                                <li><a class="dropdown-item" href="/admin/subjectlist">Subject List</a></li>

                            </ul>
                        </li>

                        <hr />
                        <li class="nav-item dropdown">
                            <a class="nav-link dropdown-toggle" role="button" data-bs-toggle="dropdown" >
                                Question Settings
                            </a>
                            <ul class="dropdown-menu">
                                <li><a class="dropdown-item" href="/admin/createquestion">Create Question</a></li>
                                <li><a class="dropdown-item" href="/admin/questionlist">Question List</a></li>

                            </ul>
                        </li>

                    </ul>
                    <hr />
                    <form class="d-flex" style={{ padding: "3%" }}>
                        <a href="/profile">
                            <i
                                class="fa fa-user-circle"
                                style={{ fontSize: 30 }}
                                aria-hidden="true"
                            >
                            </i>
                            &nbsp;
                            <span>

                                <strong>{user.name}</strong>
                                <br />
                                {user.role}
                            </span>
                        </a>
                    </form>
                </div>
            </div>
        </nav>
    );
};

export default MobileNavbarAdmin;